import { getPrePackSize } from "@faire/retailer-visitor-shared/features/PrePacks/getPrePackSize";
import { isPrePackProductOption } from "@faire/retailer-visitor-shared/features/PrePacks/isPrePackProduct";
import { logAssert } from "@faire/web/common/logging";
import { formatMoney, moneyOrZero } from "@faire/web/common/money";
import { IFaireMoney } from "@faire/web-api--source/indigofair/data/IFaireMoney";
import { IProductOption } from "@faire/web-api--source/indigofair/data/IProductOption";

export const originalPriceMoney = (selectedOption?: IProductOption): string => {
  if (!selectedOption) {
    return "--";
  }
  if (isPrePackProductOption(selectedOption)) {
    const prePackUnitCount = getPrePackSize(selectedOption.sizing_quantity);
    logAssert(
      prePackUnitCount !== 0 || !isNaN(prePackUnitCount),
      "Prepack unit count is invalid",
      {
        data: { selectedOption },
      }
    );
    const price = IFaireMoney.build({
      amount_cents:
        (selectedOption.wholesale_price?.amount_cents ?? 0) / prePackUnitCount,
      currency: selectedOption.wholesale_price?.currency,
    });
    return formatMoney({
      money: price,
    });
  }
  return formatMoney({
    money: moneyOrZero(selectedOption.wholesale_price),
  });
};
